import Swiper from 'swiper';
import 'swiper/css';
import './css/styles.css';
import 'css-star-rating/css/star-rating.min.css';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';


import './js/basicAPI';
import './js/header';
import './js/feedback.js';
import './js/trim-text-helper.js';
import './js/render-functions';

import { initArtists } from './js/artists.js';

initArtists();




